export const VACANCY_HOME_PATHS = {
    en: '/en/vacancies',
    lv: '/lv/vakances'
  } as const
  
export type VacancyLocale = keyof typeof VACANCY_HOME_PATHS
  
export const getVacancyRedirectPath = (path: string): string | null => {
  const vacancyHomePath = Object.values(VACANCY_HOME_PATHS).find((homePath) =>
    path.startsWith(`${homePath}/`)
  )
  
  return vacancyHomePath ?? null
}